module.exports = __webpack_public_path__ + "img/15.ec3ab236.png";